import _ from "lodash";
import {updateItemOrder} from "./artefacts";

export const normalizeItemsOrder = (itemsTree, childrenKey, lang) => {
  const root = {
    isRoot: true,
    [childrenKey]: itemsTree
  };

  let count = 1;

  const func = node => {
    if (!node.isRoot) {
      updateItemOrder(node, count, lang);
      count++;
    }
  };

  const visitDfs = (node, func) => {
    if (func) {
      func(node);
    }
    _.each(node[childrenKey], child => visitDfs(child, func));
  };

  visitDfs(root, func);

  return count - 1;
};

export const getNormalizedColumnName = colName =>
  colName.substring(0, 3) === "ID_"
    ? colName.substring(3, colName.length)
    : (
      colName === "_OBS_VALUE"
        ? "OBS_VALUE"
        : colName
    );
